module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/ant-star1.7b462009.png";